import React, { useState } from 'react';
import Icon from '../components/Icon';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import '../styles/Auth.css';

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  
  const [formData, setFormData] = useState({
    role: 'client',
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Hasła nie są identyczne');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Hasło musi mieć minimum 6 znaków');
      setLoading(false);
      return;
    }

    const userData = {
      role: 'client', 
      email: formData.email,
      password: formData.password,
      firstName: formData.firstName,
      lastName: formData.lastName,
      phone: formData.phone,
    };

    const result = await register(userData);
    
    setLoading(false);

    if (result.success) {
      navigate(getDashboardRoute(result.user.role), { replace: true });
    } else {
      setError(result.error);
    }
  };

  const getDashboardRoute = (role) => {
    switch (role) {
      case 'client':
        return '/dashboard/client';
      case 'salon':
        return '/dashboard/salon';
      case 'franchisee':
        return '/dashboard/franchisee';
      default:
        return '/';
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-box register-box">
          <div className="auth-header">
            <Logo size="small" dark={true} />
            <h1>Zarejestruj się</h1>
            <p>Utwórz konto klienta i zacznij rezerwować wizyty!</p>
          </div>

          {error && (
            <div className="error-message">
              <Icon name="warning" color="#f59e0b" style={{marginRight:'5px'}} /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">Imię</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Nazwisko</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="twoj@email.com"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Telefon</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={(e) => {
                  let value = e.target.value;
                  let formatted = '';

                  if (value.startsWith('+48')) {
                    let cleaned = value.substring(3).replace(/\D/g, '');
                    if (cleaned.length > 9) cleaned = cleaned.substring(0, 9);
                    
                    formatted = '+48 ';
                    if (cleaned.length > 6) {
                      formatted += cleaned.substring(0, 3) + ' ' + cleaned.substring(3, 6) + ' ' + cleaned.substring(6);
                    } else if (cleaned.length > 3) {
                      formatted += cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
                    } else {
                      formatted += cleaned;
                    }
                  } else {
                    let cleaned = value.replace(/\D/g, '');
                    if (cleaned.length > 9) cleaned = cleaned.substring(0, 9);
                    
                    formatted = cleaned;
                    if (cleaned.length > 6) {
                      formatted = cleaned.substring(0, 3) + ' ' + cleaned.substring(3, 6) + ' ' + cleaned.substring(6);
                    } else if (cleaned.length > 3) {
                      formatted = cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
                    }
                  }
                  
                  setFormData(prev => ({ ...prev, phone: formatted }));
                }}
                placeholder="+48 123 456 789"
                required
              />
            </div>

            {/* Hasło */}
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="password">Hasło</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Powtórz hasło</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Rejestracja...' : 'Zarejestruj się'}
            </button>
          </form>

          <div className="auth-footer">
            <p>Masz już konto? <Link to="/login">Zaloguj się</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
